import type { FunctionComponent, MouseEvent, ReactNode } from 'react';

import { ProficiencyScale } from '~/ui/domain/skill/ProficiencyScale';
import { SkillBadge } from '~/ui/domain/skill/SkillBadge';

import { getProficiencyScaleCount, useSkillProficiencyLevelName } from '../../../app/common/skills';
import { rowActivationIgnoredAttrs } from '../../../comments';
import type { ProfileTaskSkill } from '../model/profile-task';

export const TaskSkillRow: FunctionComponent<{
    readonly onClick: (event: MouseEvent) => void;
    readonly skill: ProfileTaskSkill;
    readonly trailing?: ReactNode;
}> = ({ onClick, skill, trailing }) => {
    const { getProficiencyLevelName } = useSkillProficiencyLevelName();

    return (
        <div className="flex w-full items-center justify-between gap-l py-s" data-testid="profile-task-skill-row">
            <div className="flex min-w-0 flex-1">
                <SkillBadge className="max-w-full" skill={skill} onClick={onClick} />
            </div>
            <div className="flex shrink-0 items-center gap-s">
                <span
                    className="flex items-center p-xs"
                    data-testid="proficiency-level"
                    title={getProficiencyLevelName({ level: skill.level ?? 0, skillType: skill.type })}
                    {...rowActivationIgnoredAttrs}
                >
                    <ProficiencyScale
                        active={true}
                        level={skill.level ?? 0}
                        scaleCount={getProficiencyScaleCount(skill.type)}
                    />
                </span>
                {trailing}
            </div>
        </div>
    );
};
